// extracted by css-extract-rspack-plugin
export default {"dropdownHeader":"dropdownHeader-cBKguC","toggle":"toggle-FAU9Fu"};